import React from "react"
import clsx from "clsx"
import Switch from "../../Switch/Switch"
import I18n from "i18n-js";
//import I18n from "i18n-js/index.js.erb"

class OrderFormBuilderCustomer extends React.Component {

  constructor(props) {
    super(props)
  }

  render() {
    var tabClasses = clsx({
      'active': this.props.active_tab == 'customer',
      'tab-pane': true
    });

    return (
      <div className={tabClasses} id="customer">
        <div className="col-md-3">
            <div className="form-group">
              <label>{`${I18n.t('internal_booking')} / ${I18n.t('customer_form')}`}  <span className="ss-help help" title={I18n.t('customer_form_helper_text')}></span></label>
              <Switch 
                onText="yes" 
                offText="no" 
                onChange={this.props.onChangeCustomerForm} 
                value={this.props.customer_form} 
                switchId="customer-field-required-switch"
              />
            </div>
        </div>
      </div>
    )
  }


  
}

export default OrderFormBuilderCustomer